enum ColumnState {
  READY_AND_PACKED = 'ready_and_packed',
  COOKING = 'COOKING',
}

export default ColumnState
